import React from 'react';

import { connect } from 'react-redux';
import classnames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import { isEmpty } from 'lodash';

import Row from './tag/Row';
import Span from './tag/Span';
import HpaAlert from './hpa/HpaAlert';
import { selectIsHpa, selectHpaColor } from '../data/hpa/selectors';
import { getName } from '../data/user/profile/selectors';

import { PagePlaceholder } from './PagePlaceholder';

import Logger from '../utils/Logger';
import Misc from '../definitions/Misc';

let { id: module_id } = module;
const logger = new Logger(module_id);

/**
 * Base for a page. handles things such as showing hpa alert when acting
 * on behalf of another user, showing a placeholder (ad/info) if user has
 * no content for page.
 */
class PageBase extends React.Component {
  componentDidMount() {
    let { title, intl } = this.props;
    //    <FormattedMessage id={`${module_id}.MUNP.careUnitDetails`}/>
    document.title = `${intl.formatMessage({
      id: title + '.browser.tab',
    })} | ${Misc.getPageTitleBase()}`;
  }

  render() {
    let { title, showTitle, hpaAlert, children, placeHolder, type } =
      this.props;
    const backButton = this.props.backButton;
    let hpaPlaceHolder = false;
    let wrapperClassName = '';

    // if placeholder is shown during hpa, show it on top of the image.
    if (hpaAlert && placeHolder) {
      hpaPlaceHolder = true;
    }
    if (placeHolder || type === 'default') {
      wrapperClassName = 'ot-mainview';
    }

    if(type === 'timeline-item-page') {
      wrapperClassName = 'ot-timeline-itemview'
    }

    return (
      <Row className={classnames(backButton && 'page-wrapper--with-button')}>
        <Span len="12" className={wrapperClassName}>
          {backButton && (
            <Span len={12} className={'ot-back'}>
              {backButton}
            </Span>
          )}
          <div
            className={classnames('page-wrapper', {
              'page-wrapper--placeholder-hpa': hpaPlaceHolder,
            })}
          >
            {
              /* If placeholder is shown, then title isn't shown. */
              !placeHolder &&
                showTitle &&
                title &&
                title !== './src/components/timeline/TimelinePage.js.title' && (
                  <Row>
                    <Span>
                      <h1 className="ot-viewtitle">
                        <FormattedMessage id={title} />
                      </h1>
                    </Span>
                  </Row>
                )
            }
            {
              /* Hpa alert is shown except when the "loader" placeholder is showing. */
              hpaAlert && placeHolder !== 'loader' && (
                <Row
                  className={classnames('hpa-alert-row', {
                    'hpa-alert-row--placeholder-hpa': hpaPlaceHolder,
                  })}
                >
                  {hpaAlert}
                </Row>
              )
            }
            {placeHolder && (
              <Row>
                <PagePlaceholder id={placeHolder}>{children}</PagePlaceholder>
              </Row>
            )}
            {!placeHolder && children}
          </div>
        </Span>
      </Row>
    );
  }
}

/**
 * PageBase HOC takes care of things common to all pages.
 * This includes title and notifying the user when they are
 * acting on behalf of another person.
 *
 * Hpa alert is shown by default.
 * */
const withPageBase = (WrappedComponent, pageBaseProps) => {
  // TODO: Separate PageBaseWrapper to it's own file
  class PageBaseWrapper extends React.Component {
    render() {
      let { isHpa, hpaName, intl, showPlaceHolder, hpaColor } = this.props;
      let {
        hpaMessage = 'hpa.alert.default',
        hpaMessageValues,
        backButton,
        title,
        showTitle = true,
        type = 'default',
      } = pageBaseProps;

      let _hpaMessageValues = hpaMessageValues || {
        name: hpaName,
        hpaColor: hpaColor,
      };

      if (isHpa && !!intl.messages[`${title}.hpa`]) {
        title = `${title}.hpa`;
      }

      return (
        <PageBase
          intl={intl}
          title={title}
          showTitle={showTitle}
          type={type}
          hpaAlert={
            isHpa ? (
              <HpaAlert message={hpaMessage} values={_hpaMessageValues} />
            ) : null
          }
          placeHolder={showPlaceHolder}
          backButton={backButton}
        >
          <WrappedComponent {...this.props} />
        </PageBase>
      );
    }
  }

  let showPlaceHolder = pageBaseProps.showPlaceHolder;

  const mapStateToProps = (state) => {
    return {
      isHpa: selectIsHpa(state),
      hpaName: getName(state),
      hpaColor: selectHpaColor(state),
      showPlaceHolder: showPlaceHolder ? showPlaceHolder(state) : null,
    };
  };

  return connect(mapStateToProps)(injectIntl(PageBaseWrapper));
};

export { withPageBase };
